import React from 'react'
import { useTranslation } from 'react-i18next';
import { FaEnvelope, FaFacebookF, FaInstagram, FaInstagramSquare, FaLinkedinIn, FaMailBulk, FaReact, FaTelegram, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { SiTailwindcss, SiFigma, SiNextdotjs } from "react-icons/si";
const Media = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          {t("banner.findMe")}
        </h2>
        <div className="flex gap-4 flex-wrap">
          <a
            href="https://www.facebook.com/moayad.ismail.524/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="bannerIcon">
              <FaFacebookF />
            </span>
          </a>
          <a
            href="https://wa.me/968577071"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="bannerIcon">
              <FaWhatsapp />
            </span>
          </a>
          <a
            href="https://t.me/MoayadIsmail99"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="bannerIcon">
              <FaTelegramPlane />
            </span>
          </a>
          <a
            href="mailto:business@moayadismail.com"
          >
            <span className="bannerIcon">
              <FaEnvelope />
            </span>
          </a>
          <a
            href="https://www.instagram.com/moayad.ismail.99/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="bannerIcon">
              <FaInstagram />
            </span>
          </a>
        </div>
      </div>
      {/* <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          BEST SKILL ON
        </h2>
        <div className="flex gap-4">
          <span className="bannerIcon ">
            <FaReact />
          </span>
          <span className="bannerIcon ">
            <SiNextdotjs />
          </span>
          <span className="bannerIcon ">
            <SiTailwindcss />
          </span>
          <span className="bannerIcon ">
            <SiFigma />
          </span>
        </div>
      </div> */}
    </div>
  )
}

export default Media